import agendaApiConfig from "./agendaApiConfig";

const SucursalService = {
    async getAll () {
        let query =  {}; 
        if(process.env.REACT_APP_SERVICIO == ""){
            query = null;
        }else{
            query =  {ser_codigo : process.env.REACT_APP_SERVICIO }; 
        }
        return await agendaApiConfig.get("/sucursal", {
            params: {
                ...query
            }
        });
    }
}

export default SucursalService;